(function () {
    'use strict';

    angular.module('app.charts')
        .directive('donutGaugeChart', donutGaugeChart);

    /* @ngInject */
    function donutGaugeChart(SETTINGS, DataFactory, $rootScope) {
        return {
            restrict: 'E',
            template: '<div class="chart-header"><div ng-if="logoUrl"><img class="logo" src="{{logoUrl}}" /></div><div><h3 class="chart-title">{{chartTitle}}<span class="sub" ng-if="subtitle">{{subtitle}}</span></h3></div><i class="icon-cloud-download" ng-click="exportChart()" title="Download chart"></i></div><div class="cl-chart cl-chart-donut" id="{{id}}_chart"></div><p ng-if="footer" class="footnote">{{footer}}â€‹</p>',
            scope: {
                id: '@',
                chartTitle: '@',
                subtitle: '=',
                chartDataKey: '@',
                filter: '=',
                eventHandler: '=',
                color: '@',
				hideLabels: "@",
				legendPosition: "@",
				logoUrl: '@',
                text: '@'
            },
            link: link
        };

        function link(scope, elm, attrs) {

            var chart;
	        var hiddenChart,
	            hiddenID = scope.id + '_hidden',
	            exportW = 800,
	            exportH = 600,
				masterData,
				filter,
				unit = '%',
				legendPosition = 'right',
				filteredData
			;

            var colors = [];
			var chartText = '';
			var hideLabels = false;

            if (angular.isUndefined(scope.color)) {
                colors = SETTINGS.PALETTE;
            } else {
                colors.push(scope.color);
            }
            colors.push('#cccccc');

            if (angular.isDefined(scope.text)) {
				chartText = scope.text;
            }

            if (angular.isDefined(scope.hideLabels)) {
				hideLabels = scope.hideLabels === true || scope.hideLabels === "true";
            }

            if (angular.isDefined(scope.legendPosition)) {
				legendPosition = scope.legendPosition;
            }

            if (angular.isDefined(scope.unit)) {
				unit = scope.unit;
            }

            elm.append('<div class="chart-hidden" id="' + hiddenID + '"></div>');

			function dataChanged(){
                if (masterData && masterData.data != undefined) {
					if (angular.isDefined(filter) && filter != null && filter != '') {
						filteredData = masterData.data[filter];
					} else {
						filteredData = masterData.data
					}
					if (angular.isArray(filteredData)) {
						angular.forEach(filteredData, function(item){
							if (angular.isUndefined(item.labelColor)) {
								item.labelColor = '#ffffff';
							}
						});
					}
                    if (chart == undefined) {
                        render();
                    }
                    chart.dataProvider = filteredData;
                    chart.validateData();

					// footer
					var footer = DataFactory.getSamplesString(masterData, filter);
					scope.footer = footer;
                }
			}

			if (angular.isDefined(scope.chartDataKey)) {
				DataFactory.getJSON(scope.chartDataKey).then(function(response) {
					masterData = response;
					DataFactory.injectSampleInfo(masterData);
					dataChanged();
				});

	            if (angular.isDefined(scope.filter)) {
					filter = scope.filter;
		            scope.$watch('filter', function(newVal){
		            	filter = newVal;
						dataChanged();
		            });
	            } else if (angular.isDefined($rootScope.dataFilterSelected)){
	            	filter = $rootScope.dataFilterSelected.value;
		            $rootScope.$watch('dataFilterSelected', function(newVal){
		            	filter = newVal.value;
						dataChanged();
		            });
	            }
			}

            function render() {
				var valueField = masterData && angular.isDefined(masterData.meta) && angular.isArray(masterData.meta.series) && masterData.meta.series.length > 0 ? masterData.meta.series[0] : "value";

				var config = {
                    "type": "pie",
                    "colors": colors,
                    "balloonText": "",
                    "innerRadius": "50%",
                    "labelRadius": -35,
					"labelColorField" : "labelColor",
                    "labelText": hideLabels ? "" : "[[" + valueField + "]]" + unit,
                    "fontSize": 16,
                    "radius": "45%",
                    "titleField": "Category",
                    "valueField": valueField,
                    "allLabels": [
                        {
                            "align": "center",
                            "bold": true,
                            "size": 30,
                            "text": chartText,
                            "y": "38%"
                        }
                    ],
                    "legend": {
                        enabled: true,
                        position: legendPosition,
                        valueText: '',
                        fontSize: 12,
                        switchable: SETTINGS.CHARTS.LEGEND.SWITCHABLE,
                        color: SETTINGS.CHARTS.TEXT.COLOR
                    },
                    "dataProvider": filteredData,
					"listeners": []
                };

				if (angular.isDefined(scope.eventHandler)) {
					config["listeners"].push({
						"event": "dataUpdated",
						"method": scope.eventHandler
					});
				}

                chart = AmCharts.makeChart(scope.id + "_chart", config, 100); // todo why is this delay needed? what hasn't loaded and how do we detect when it is loaded?

                function exportChart() {

                    var exportConfig = {};

                    var hiddenDiv = angular.element(document.getElementById(hiddenID));
                    hiddenDiv.css({
                        width: exportW + 'px',
                        height: exportH + 'px'
                    });

                    // Copy visible chart config
                    angular.copy(config, exportConfig);

                    exportConfig.startDuration = 0;
                    exportConfig.radius = '30%';
					exportConfig.labelRadius = -45;
                    exportConfig.autoMargins = false;
                    exportConfig.marginLeft = 100;
                    exportConfig.marginRight = 100;
                    exportConfig.marginTop = 80;
                    exportConfig.marginBottom = 80;

                    // Update data
                    exportConfig.dataProvider = filteredData;

                    exportConfig.legend.autoMargins = false;
                    exportConfig.legend.marginRight = 50;
					exportConfig.legend.position = 'right';

                    if (angular.isDefined(scope.chartTitle)) {
                        exportConfig.marginTop += 50;
                    }

                    if (angular.isDefined(scope.subtitle)) {
                        exportConfig.marginTop += 30;
                    }

                    if (angular.isDefined(scope.footer)) {
                        exportConfig.marginBottom += 70;
                    }

                    exportConfig.export = {
                        enabled: true,
                        libs: {
                            autoLoad: false
                        },
                        menu: [],
                        afterCapture: function () {
                            var instance = this;

                            // Logo
                            var imgEl = document.querySelector('#chart-header-img');

                            if (imgEl !== null) {
                                var logo = new fabric.Image(imgEl, {
                                    left: exportW - imgEl.width,
                                    top: 20
                                });
                                instance.setup.fabric.add(logo);
                            }

                            // Title
                            if (angular.isDefined(scope.chartTitle)) {
                                var title = new fabric.Text(scope.chartTitle, {
                                    left: 30,
                                    top: 50,
                                    fontFamily: SETTINGS.FONT_FAMILY,
                                    fontSize: 18
                                });
                                instance.setup.fabric.add(title);
                            }

                            if (angular.isDefined(scope.subtitle)) {
                                var subtitle = new fabric.Text(scope.subtitle, {
                                    left: 30,
                                    top: 80,
                                    fontFamily: SETTINGS.FONT_FAMILY,
                                    fontSize: 15
                                });
                                instance.setup.fabric.add(subtitle);
                            }

                            // footer
                            if (angular.isDefined(scope.footer)) {
                                var footer = new fabric.Text(scope.footer, {
                                    left: 30,
                                    top: exportH - 50,
                                    fontFamily: SETTINGS.FONT_FAMILY,
                                    fontSize: 10
                                });
                                instance.setup.fabric.add(footer);
                            }
                        }
                    };

                    hiddenChart = AmCharts.makeChart(hiddenID, exportConfig);

                    hiddenChart.export.capture({}, function () {
                        this.toPNG({multiplier:2}, function (data) {
                            this.download(data, this.defaults.formats.PNG.mimeType, scope.chartTitle);
                        });
                    });
                }

                scope.exportChart = exportChart;
            }
        }
    }
})();
